<template>
  <div>
    <div>

      <div class="red">

        <div class="loader" v-if="loading"></div>

        <div class="text-center">

          <b-form-file v-model="file1" :state="Boolean(file1)" placeholder="Choose a file or drop it here..."
            drop-placeholder="Drop file here..."></b-form-file>
          <div class="mt-3">Selected file: {{ file1 ? file1.name : '' }}</div>

        </div>

      </div>

    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import swal from "../../services/swal";
import { isMobile } from "mobile-device-detect";
import AppStyle from '@/plugins/appStyle';

export default {
  mixins: [AppStyle.Mixin],
  name: "photo-book-image-uploader",
  components: {
  },
  props: {
    photo_book_id: 0,
    imagetype: '',
    image: null,
    
  },
  data() {
    return {
      loading: false,
      hasProcessableImage: false,
      showUpload: false,
      thul: true,
      file1: '',
    };
  },
  methods: {

    apiOcr(evt) {
      //this.$emit("pictureTaken", this.currentPic);
      //this.displayCamUpload = false;
    },

    handleImageUl(e) {
      this.toggleFileUploadView();
      const selectedImage = e.target.files[0]; // get first file
      this.createBase64Image(selectedImage);
    },
    createBase64Image(fileObject) {
      const reader = new FileReader();
      reader.onload = (e) => {
        this.currentPic.img = e.target.result;
      };
      reader.readAsDataURL(fileObject);
    },

    toggleFileUploadView() {
      //  this.currentPic.img = null;
      this.showCam = false;
      this.showUpload = true;
    },
    resetToStart() {
      toggleFileUploadView();
    },
  },
  computed: {

    mobile: function () {
      //console.log(isMobile);
      return isMobile ? true : false;
      //return (this.isMobile ? false : true);
    },
  },

  mounted() {
    console.log("data here");
    this.$refs.book.nextPage();
  },
};
</script>